<template>
  <div v-if="isVisible" class="side-panel-wdith-curtain">
    <div :style="{ width: sidebarWidth }" class="panel-container vh-100">
      <header class="panel-header">
        <div
          v-if="leftCommand"
          id="btnCancel"
          class="panel-cancel panel-left-item panel-navitem ml-1 mr-3"
        >
          <icon
            v-if="!cancel"
            @click.native="$emit('cancel')"
            styles="panel-navitem text-primary"
            type="backButton"
          />
          <BtnLink
            v-if="cancel"
            @click.native="$emit('cancel')"
            class="text-primary"
            :loading="loading"
            :label="cancel"
            :disabled="false"
          />
        </div>
        <div class="text-panel-header text-weight-bold">
          {{ header }}
        </div>
        <div v-if="rightCommand" id="btnSave" class="panel-right-item">
          <icon
            v-if="!save"
            @click.native="$emit('save')"
            styles="panel-navitem text-dark-grey"
            type="close"
          />
          <Btn
            v-if="save"
            @click.native="$emit('save')"
            :loading="loading"
            :label="save"
            :disabled="disable"
          />
        </div>
      </header>
      <perfect-scrollbar v-if="0">
        <div :class="scrolling" class="panel-body">
          <slot></slot>
        </div>
      </perfect-scrollbar>
      <div :class="scrolling" class="panel-body">
        <slot></slot>
      </div>
    </div>
  </div>
</template>
<script>
import Icon from '@/components/UI/Icon.vue';

export default {
  name: 'SidePanel',

  props: {
    isVisible: {
      type: Boolean,
      required: true,
    },
    header: {
      type: String,
      required: false,
    },

    leftCommand: {
      type: Boolean,
      default: true,
    },

    rightCommand: {
      type: Boolean,
      default: false,
    },

    cancel: {
      type: String,
      required: false,
    },

    save: {
      type: String,
      required: false,
    },

    width: {
      type: Number,
      required: false,
      default: 546,
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
    disable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showModal: false,
      isScrollingEnabled: true,
      clientWidth: 0,
      screenWidth: 0,
      orientation: 0,
    };
  },

  components: {
    Icon,
  },

  methods: {
    updateScreenValues() {
      this.screenWidth = screen.width;
      this.orientation = screen.orientation
        ? window.orientation
        : window.orientation;
      this.clientWidth = this.getClientWidth();
    },

    getClientWidth() {
      let clientWidth = screen.width;
      if (this.isIOSDevice && this.orientation && this.orientation != 0) {
        clientWidth = screen.height;
      }
      return clientWidth;
    },

    disableScrolling() {
      console.log('SidePanel - disable scrolling');
      this.isScrollingEnabled = false;
    },

    enableScrolling() {
      console.log('SidePanel - enable scrolling');
      this.isScrollingEnabled = true;
    },

    onClose() {
      this.showModal - false;
    },

    onConfirm() {
      this.showModal - false;
    },

    toggle() {
      if (this.showModal) {
        this.showModal = false;
      } else {
        this.showModal = true;
      }
      console.log('Toggle dialog:', this.showModal);
    },
  },
  computed: {
    mobileView() {
      return this.$store.state.mobileView;
    },

    scrolling() {
      if (this.isScrollingEnabled) return null;
      return 'overflow-hidden';
    },

    isMobileScreen() {
      return this.clientWidth < 640;
    },

    sidebarWidth() {
      if (this.isMobileScreen) {
        return '100%';
      }
      return this.width + 'px';
    },
  },

  mounted() {
    const viewportContent = 'width=device-width initial-scale=1.0';
    document
      .querySelector("meta[name='viewport']")
      .setAttribute('content', viewportContent);
    this.updateScreenValues();
  },
  beforeDestroy() {
    if (this.isMobileScreen && !this.mobileView) {
      const viewportContent =
        'width=device-width initial-scale=0.8 maximum-scale=1.0';
      document
        .querySelector("meta[name='viewport']")
        .setAttribute('content', viewportContent);
    }
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/colors.scss';

.ps {
  height: calc(100% - 54px);
}

.side-panel-wdith-curtain {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 30001;
  background-color: rgba(0, 0, 0, 0.2);
  -webkit-animation-name: fade-in;
  animation-name: fade-in;
  -webkit-animation-duration: 0.25s;
  animation-duration: 0.25s;
  -webkit-overflow-scrolling: touch;
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
}

.panel-container {
  position: absolute;
  background: $side-panel-bg;
  height: 100vh;
  display: flex;
  flex-direction: column;
  left: auto;
  right: 0;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);
}

.panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 54px;
  background: white;
  box-sizing: border-box;
  z-index: 1;
  flex-shrink: 0;
}

.panel-header:not(.panel-header-with-content) {
  box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.12);
}

.panel-left-item,
.panel-right-item {
  cursor: pointer;
}

.panel-left-item {
  /* width: 90px; */
  padding-left: 8px;
  text-align: left;
  display: flex;
  justify-content: flex-start;
}

.panel-header h3 {
  font-size: 0.9rem;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.87);

  text-align: center;
  padding-top: 10px;
  padding-bottom: 10px;
  margin: 0px;
}

.panel-body {
  display: flex;
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: auto;
  overflow: auto;
  padding: 00px;
  border: 0px solid #000;
}

.panel-right-item {
  width: fit-content;
  padding-right: 8px;
  text-align: right;
  display: flex;
  justify-content: flex-end;
}

@media screen and (max-width: 640px) {
  .panel-container {
    width: 100%;
  }
}

.text-button:hover,
.text-button:hover:visited {
  background: rgba(255, 64, 129, 0.12);
  color: #ff4081;
}

.narrow-button {
  padding: 0px 8px;
}

.modal-confirm {
  overflow-x: hidden;
  overflow-y: auto;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9;
  color: $dark-grey;
  &__backdrop {
    background-color: rgba(0, 0, 0, 0.3);
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1;
  }
  &__dialog {
    background-color: #ffffff;
    position: relative;
    width: 600px;
    margin: 50px auto;
    display: flex;
    flex-direction: column;
    border-radius: 5px;
    z-index: 2;
    // -webkit-transform: translate3d(0, 0, 0);
    @media screen and (max-width: 767px) {
      width: 90%;
      max-width: 600px;
    }
  }
  &__close {
    width: 30px;
    height: 30px;
  }
  &__header {
    padding: 20px 20px 10px;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    font-size: 20px;
    @media screen and (max-width: 480px) {
      font-size: 16px;
    }
  }
  &__body {
    padding: 10px 20px 10px;
    overflow: auto;
    display: flex;
    flex-direction: column;
    align-items: stretch;
  }
  &__footer {
    margin: 10px;
    margin-top: 0px;
    padding-top: 10px;
    border-top: 1px solid $light-grey;
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.overflow-hidden {
  overflow: hidden;
}
</style>
